import type { GarageView, WorkshopBookingListQuery } from '@chukua/common';
import { Select } from 'antd';
import type { ListQueryControls } from '../../../../../shared/hooks/use-list-query';

interface BookingsToolbarProps {
  list: Pick<ListQueryControls<WorkshopBookingListQuery>, 'query' | 'setQuery'>;
  /** Null until loaded; the select then shows loading rather than "no garages". */
  garages: GarageView[] | null;
}

/** Filter by workshop: a garage's own list of bookings. Lives in the URL query with the rest. */
export function BookingsToolbar({ list, garages }: BookingsToolbarProps) {
  return (
    <Select
      mode="multiple"
      allowClear
      loading={garages === null}
      className="w-full md:w-64"
      placeholder="Select or search workshops"
      aria-label="Workshops"
      optionFilterProp="label"
      options={(garages ?? []).map((garage) => ({ value: garage.id, label: garage.name }))}
      value={list.query.garageId ?? []}
      onChange={(garageId: string[]) => list.setQuery({ garageId })}
    />
  );
}
